import { render } from "./WarningScreen.vue?vue&type=template&id=4150635c"
import script from "./WarningScreen.vue?vue&type=script&lang=js"
export * from "./WarningScreen.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__